// import CartTimer from "@shared/components/application/data-display/CartTimer/CartTimer.web";
import { domElementIds } from "@shared/constants/common";
import Box from "@ui-kit/layout/Box/Box.web";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import dynamic from "next/dynamic";
import { NavBarBannersProps } from "./NavBarBanners.props";
import NavBarExchangeBanner from "./NavBarExchangeBanner.web";

const CartTimer = dynamic(
  () =>
    import(
      "@shared/components/application/data-display/CartTimer/CartTimer.web"
    ),
  {
    ssr: false,
  }
);

/**
 * Contains all navbar banners that can be displayed on the site.
 * Currently, has: Cart Timer Banner, Exchange Banner
 */
export default function NavBarBanners({
  isDetailsPage = false,
  isReactNativeApp = false,
}: NavBarBannersProps) {
  return (
    <Flex
      top="none"
      direction="column"
      id={domElementIds.navbarBannerId}
      zIndex="var(--z-index-navbar-tabs)"
      position={isReactNativeApp ? "relative" : "sticky"}
    >
      {/* Cart Timer Banner */}
      {/* Hide the banner when not on a purchase page */}
      {isDetailsPage && (
        <Box position="sticky" backgroundColor="red.100">
          <Box
            w="full"
            maxWidth="1520"
            mx="auto"
            px={{ base: "lg", sm: "3xl" }}
          >
            <CartTimer />
          </Box>
        </Box>
      )}
      {/* Exchange Banner */}
      <NavBarExchangeBanner />
    </Flex>
  );
}
